import * as THREE from 'three';
import { CircularArray } from './circularArray.js';
import FPSHistory from './fpsHistory.js';

// Handles adjustment of quality levels to maintain a target fps
export class PerformanceManager {
    // Quality levels
    static QUALITY = {
        low: {
            'shadows': false,
            'pixelRatio': 0.5,
            'index': 0
        },
        medium: {
            'shadows': false,
            'pixelRatio': 0.8,
            'index': 1,
        },
        high: {
            'shadows' : true,
            'pixelRatio': 1,
            'index': 2
        },
    }

    static QUALITY_NAMES = ["low", "medium", "high"]


    static targetFPS = 59;

    // Time to wait after changing quality to consider changing quality again
    static debounceTime = 1; // seconds

    // Time to wait initially before changing quality
    static gracePeriod = 2; // seconds

    constructor(renderer, gpuTier, minFPS=0, maxFPS=120) {
        this.gpuTier = gpuTier;
        this.clock = new THREE.Clock();
        // this.fpsHistory = new CircularArray(10);
        this.renderer = renderer;
        this.quality = 'high';
        this.minFPS = minFPS;
        this.maxFPS = maxFPS;
        this.fpsHistory = {}
        

        this.averageTotalTime = 0; // seconds
        // this.averageResetTime = 2; // seconds
        this.debounceTimer = 0; // seconds

        // if (gpuTier.isMobile) {
        //     this.quality = 'low';
        // }
        
        // These get set later as resources are loaded in
        this.sun = null;
        this.performanceMonitorData = {};
        this.performanceMonitorData.currentQuality = "";
        this.performanceMonitorData.quality = {};
        for (const [key, value] of Object.entries(PerformanceManager.QUALITY)) {
            this.fpsHistory[key] = new FPSHistory(minFPS, maxFPS);
            this.performanceMonitorData.quality[key] = {
                averageFPS: -1,
                medianFPS: -1,
                totalSamples: -1,
                stdDeviation: -1,
            };
        }
    }

    setSun(sun) {
        this.sun = sun;
    }

    getOffsetQuality(offset) {
        const qIndex = PerformanceManager.QUALITY[this.quality].index;

        // Check if next quality is in bounds
        if (qIndex + offset < 0 || qIndex + offset >= PerformanceManager.QUALITY_NAMES.length)
            return null;

        return PerformanceManager.QUALITY_NAMES[qIndex + offset];
    }

    // If we were to switch, what quality would we switch to. Null means don't switch
    shouldSwitchQualityTo() {

        // if (this.debounceTimer > 0)
        //     return null;

        const avg = this.fpsHistory[this.quality].median();

        // Try switching down if our average fps is too low
        if (avg < PerformanceManager.targetFPS)
            return this.getOffsetQuality(-1);

        // Decide if we should switch up
        if (avg >= PerformanceManager.targetFPS ) {
            
            const nextQuality = this.getOffsetQuality(1);
            if (!nextQuality)
                return null;

            // debugger;

            // Check if there's already an fps history for this quality
            // Don't switch if we've already established a median fps on that quality that's lower than the target
            // if (this.fpsHistory[nextQuality] && this.fpsHistory[nextQuality].median() < PerformanceManager.targetFPS)
            //     return null;

            return nextQuality;
        }

        return null;
    }

    tick() {
        const delta = this.clock.getDelta();

        if (delta <= 0) 
            return;
        
        this.fpsHistory[this.quality].sample(Math.floor(1 / delta));
        // this.averageTotalTime += delta;
        this.debounceTimer -= delta;

        // Short circuit if we're still within the initial load grace period
        if (this.clock.getElapsedTime() < PerformanceManager.gracePeriod)
            return;

        if (this.debounceTimer <= 0) {

            // console.log('Considering a change of quality');
            const nextQuality = this.shouldSwitchQualityTo();

            // Reset the average
            // this.fpsHistory[this.quality].resetAvg();

            // Restart the debounce timer
            this.debounceTimer = PerformanceManager.debounceTime;

            if (nextQuality) {

                // Create the fps history object for the next quality if necessary
                if (!this.fpsHistory[nextQuality])
                    this.fpsHistory[nextQuality] = new FPSHistory(this.minFPS, this.maxFPS);

                this.setQualityLevel(nextQuality);
            }
        }
        this.updatePerformanceMonitorData();
    }

    setQualityLevel(level) {

        // Short circuit if we're already at this quality
        if (this.quality == level)
            return;

        console.log('Setting quality to ' + level);
        const quality = PerformanceManager.QUALITY[level];
        console.log(this.renderer.shadowMap);
        console.log(this.sun);
        this.renderer.shadowMap.enabled = quality.shadows;
        if (!quality.shadows) {
            if (this.sun) {
                this.sun.castShadow = false;
                // this.renderer.setRenderTarget(this.sun.shadow.map);
                // this.renderer.clear();
                // this.renderer.setRenderTarget(null);
                // this.sun.shadow.needsUpdate = true;
            }
        } else {
            if (this.sun) {
                this.sun.castShadow = true;
            }
        }
        this.renderer.needsUpdate = true;
        this.renderer.setPixelRatio(window.devicePixelRatio * quality.pixelRatio);
        this.quality = level;
    }

     updatePerformanceMonitorData() {
        this.performanceMonitorData.currentQuality = this.quality;
        for (const [key, value] of Object.entries(PerformanceManager.QUALITY)) {
            this.performanceMonitorData.quality[key].medianFPS = this.fpsHistory[key].median();
            this.performanceMonitorData.quality[key].averageFPS = this.fpsHistory[key].avg();
            this.performanceMonitorData.quality[key].totalSamples = this.fpsHistory[key].totalSamples;
            this.performanceMonitorData.quality[key].stdDeviation = this.fpsHistory[key].stdDeviation();
        }
    }
}